module.exports = __webpack_public_path__ + "img/bg.95ce6e15.jpg";